import { FC } from 'react';

import { IconProps } from '.';

export const UserIcon: FC<IconProps> = ({
  width = 20,
  height = 20,
  color = '#D4D4D4',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.667A4.596 4.596 0 0 0 5.417 6.25 4.596 4.596 0 0 0 10 10.833a4.596 4.596 0 0 0 4.583-4.583A4.596 4.596 0 0 0 10 1.667m0 1.666a2.904 2.904 0 0 1 2.917 2.917A2.904 2.904 0 0 1 10 9.166 2.904 2.904 0 0 1 7.083 6.25 2.904 2.904 0 0 1 10 3.333m-2.083 8.75c-1.163 0-1.805-.02-2.46.18A4.17 4.17 0 0 0 2.68 15.04c-.199.655-.179 1.297-.179 2.46a.833.833 0 0 0 1.667 0c0-1.163.019-1.685.107-1.976a2.5 2.5 0 0 1 1.667-1.667c.291-.088.813-.107 1.976-.107h4.166c1.163 0 1.684.019 1.976.107a2.5 2.5 0 0 1 1.667 1.667c.088.292.107.813.107 1.976a.833.833 0 0 0 1.667 0c0-1.163.02-1.805-.18-2.46a4.17 4.17 0 0 0-2.777-2.778c-.655-.199-1.297-.179-2.46-.179z"
      fill={color}
    />
  </svg>
);
